export interface Menu {
    created_at: string;
    enabled: boolean;
    id: number;
    image_url: string;
    menu_order: string;
    menu_type: string;
    name: string;
    tenant_id: number;
    updated_at: string;
}
